import { render, staticRenderFns } from "./MostSuggestionAllUsers.vue?vue&type=template&id=3c5efb0f&scoped=true&"
import script from "./MostSuggestionAllUsers.vue?vue&type=script&lang=js&"
export * from "./MostSuggestionAllUsers.vue?vue&type=script&lang=js&"
import style0 from "./MostSuggestionAllUsers.vue?vue&type=style&index=0&id=3c5efb0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5efb0f",
  null
  
)

export default component.exports